<template>
  <h2 class="h2-medium">{{ degreesTitle }}</h2>
  <h2 class="h2-medium">{{ degreesDescription }}</h2>
  <div class="row gx-0">
    <div
      class="col-12 col-md-7 position-relative cih-bg-image rds-lazy mt-lg-space-lg mt-space-sm"
      :data-background-image="bgImageSource"
      role="img"
      :aria-label="bgImageAlt"
    ></div>
    <div class="col-12 col-md-5 mt-lg-space-lg mt-space-sm">
      <div class="card-body cih-body px-lg-space-md ps-md-space-sm">
        <!-- title -->
        <h2 class="h2-small mb-space-xs" v-html="title"></h2>
        <!-- slot -->
        <h3 class="h3-small">{{ label }}</h3>
        <p
          class="fs-small mt-space-xxxs mb-space-sm mb-lg-space-sm text-dark-1"
        >
          {{ year }}
        </p>
        <hr class="d-flex custom-line" />
        <div
          class="mt-space-md mb-space-xxs"
          v-if="handleDisplayMarketingImage"
        >
          <img :src="marketingImageSrc" :alt="marketingImageAlt" />
        </div>

        <!-- footer -->
        <div class="col-12">
          <div class="mb-0 fs-medium" v-html="footerText"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  bgImageSource: string;
  bgImageAlt: string;
  degreesTitle: string;
  degreesDescription: string;
  title: string;
  label: string;
  year: string;
  footerText: string;
  marketingImageSrc?: string;
  marketingImageAlt?: string;
}

const props = withDefaults(defineProps<Props>(), {});

const handleDisplayMarketingImage = computed<boolean>(() => {
  const { marketingImageSrc } = props;
  if (typeof marketingImageSrc === "undefined" || marketingImageSrc === null) {
    return false;
  }
  return true;
});
</script>

<style lang="scss" scoped>
.custom-line {
  background-color: var(--rds-light-4);
}

.cih-bg-image {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  height: 360px;
}

div.cih-body {
  padding: 0;
}
</style>
